function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-859.000000, -322.000000)",
  fill: "#003C57",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "869 337.27 875.18 341 873.54 333.97 879 329.24 871.81 328.63 869 322 866.19 328.63 859 329.24 864.46 333.97 862.82 341"
})));

function SvgIconStarred(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20"
  }, props), _ref);
}

export default __webpack_public_path__ + "03429170a7fa9b39dc04985a9bb598c5.svg";
export { SvgIconStarred as ReactComponent };